
import { createSlice } from '@reduxjs/toolkit';

export const policySlice = createSlice({
  name: 'policy',
  initialState: {
    policyValues: {},

  },
  reducers: {
    setPolicyValues: (state, action) => {
      state.policyValues = action.payload;
    },
  }
});

export const {
  setPolicyValues,
} = policySlice.actions

export default policySlice.reducer;
